import React from 'react'
import { CardContentInner, useListContext } from 'react-admin'
import { LoadingImageGrid } from './LoadingImageGrid'
import { ImageGridBodyProps } from './type'
import { ImageGridBody } from './ImageGridBody'
import { useColsForWidth } from '../../hooks/useColsForWidth'

export const ImageGrid: React.FC<ImageGridBodyProps> = ({
  children,
  rowClick = 'edit',
  rowHeight = 180,
  ...props
}) => {
  const { isLoading } = useListContext()
  const cols = useColsForWidth()
  if (isLoading)
    return (
      <CardContentInner>
        <LoadingImageGrid rowHeight={rowHeight} cols={cols} {...props} />
      </CardContentInner>
    )
  return (
    <CardContentInner>
      <ImageGridBody rowClick={rowClick} rowHeight={rowHeight} cols={cols} {...props}>
        {children}
      </ImageGridBody>
    </CardContentInner>
  )
}

ImageGrid.displayName = 'ImageGrid'
